import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../Navigation/components/Button';
import { useGlobalStateContext } from '../context/GlobalStateContext/GlobalStateContext';
import { redirectToLogOut } from '../utils/browser-helpers';
const ErrorPage = ({ type }) => {
    const navigate = useNavigate();
    const { t: text } = useTranslation();
    const { handleLogout } = useGlobalStateContext();
    const handleLogoutClickWithAPI = () => {
        handleLogout(redirectToLogOut);
    };
    const errorStates = {
        401: {
            img: 'access_blocked',
            title: 'ERROR_PAGE_401_TITLE',
            subtitle: 'ERROR_PAGE_401_SUBTITLE',
            button: 'ERROR_PAGE_401_BUTTON',
            onButtonClick: redirectToLogOut,
        },
        403: {
            img: 'access_blocked',
            title: 'ERROR_PAGE_403_TITLE',
            subtitle: 'ERROR_PAGE_403_SUBTITLE',
            button: 'ERROR_PAGE_403_BUTTON',
            onButtonClick: handleLogoutClickWithAPI,
        },
        404: {
            img: '404',
            title: 'ERROR_PAGE_404_TITLE',
            subtitle: 'ERROR_PAGE_404_SUBTITLE',
            button: 'ERROR_PAGE_404_BUTTON',
            onButtonClick: () => navigate('/sales'),
        },
        411: {
            img: 'loading-error',
            title: 'ERROR_PAGE_411_TITLE',
        },
        500: {
            img: 'not_found',
            title: 'ERROR_PAGE_500_TITLE',
            subtitle: 'ERROR_PAGE_500_SUBTITLE',
            button: 'ERROR_PAGE_500_BUTTON',
            onButtonClick: () => navigate('/sales'),
        },
        503: {
            img: 'not_found',
            title: 'ERROR_PAGE_503_TITLE',
            subtitle: 'ERROR_PAGE_503_SUBTITLE',
            button: 'ERROR_PAGE_503_BUTTON',
            onButtonClick: () => navigate('/sales'),
        },
    };
    const errorState = errorStates[type] || errorStates[500];
    return (_jsxs(Box, { sx: {
            height: { desktop: 'calc(100vh - 58px - 3.75rem)', mobile: 'calc(100vh - 58px)' },
            overflow: 'hidden',
            position: 'relative',
        }, children: [_jsx(Box, { sx: styles.bg, children: _jsx("img", { src: `${process.env.BASE_URL}/assets/images/error-bg.svg`, className: 'main-bg', width: '100%' }) }), _jsxs(Box, { sx: styles.mainContainer, children: [_jsx("img", { src: `${process.env.BASE_URL}/assets/images/${errorState.img}.svg`, alt: errorState.img, width: `${420}px` }), errorState?.title && _jsx(Typography, { variant: 'h1', children: text(errorState.title) }), errorState?.subtitle && (_jsx(Typography, { variant: 'subtitle2', sx: { mt: '10px' }, children: text(errorState.subtitle) })), errorState?.button && (_jsx(Box, { sx: { minWidth: '142px' }, children: _jsx(Button, { variant: 'secondary', onClick: errorState.onButtonClick, fullWidth: true, children: text(errorState.button) }) }))] })] }));
};
export default ErrorPage;
const styles = {
    mainContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        height: '100%',
        justifyContent: 'center',
        px: { desktop: '30%', mobile: '15%' },
        textAlign: 'center',
        '& img': {
            maxWidth: '100%',
        },
        '& .MuiTypography-h1': {
            color: '#000',
            fontSize: '2rem',
        },
        '& .MuiTypography-subtitle2': {
            color: 'secondary.dark',
        },
        '& button': {
            px: '18px',
        },
    },
    bg: {
        '& img': {
            position: 'absolute',
            top: '10%',
            zIndex: -1,
        },
    },
};
